import { FormEvent, ReactElement, useContext, useEffect, useState } from 'react';
import { AlertI, Button } from './Button';
import { InputField } from './InputField';
import ConfirmPassword from './ConfirmPassword';
import { resetPassword } from '../http';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../auth-context';
import { Localize } from '@biniyog/localize';

/* eslint-disable-next-line */
interface Props {
  submitDisable?: boolean;
}

export default function ResetPassword({ submitDisable }: Props): ReactElement {
  const [step, setStep] = useState<number>(1);
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [alert, setAlert] = useState<AlertI | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { authError } = useContext(AuthContext);

  useEffect(() => {
    const step = localStorage.getItem('step');
    if (Number(step)) {
      setStep(Number(step));
    } else {
      setStep(1);
    }
    return () => {
      setStep(1);
    };
  }, []);
  useEffect(() => {
    if (authError === 'PASSWORD_EXPIRED') {
      setAlert({
        type: 'error',
        message: 'Your password has expired, please reset your password before you can continue',
      });
    }
    if (authError === 'SUSPICIOUS_LOGIN_ATTEMPTS') {
      setAlert({
        type: 'error',
        message: 'Your account has been locked. Please update your password to get back to the account',
      });
    }
  }, [authError]);
  const handleSubmit = (evt: FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    if (email.length) {
      localStorage.setItem('email', email);
      //make api request here with email
      setLoading(true);
      resetPassword(email)
        .then((res) => {
          setAlert({
            type: 'success',
            message:
              'If a matching account was found an email will sent to email address to allow you to reset your password.Please check spam if not available in your inbox',
          });
          setTimeout(() => {
            setStep(2);
            localStorage.setItem('step', '2');
            setLoading(false);
          }, 500);
        })
        .catch(function (err) {
          const error = err?.response?.data;
          setAlert({
            type: 'error',
            message: error.message,
          });
          setLoading(false);
        });
    } else {
      setError('Email is required');
    }
  };
  return (
    <Localize>
      <section>
        <div className="flex-b">
          <span className="text-gray text-left font-size m-0">Reset Password</span>
          <NavLink to="/" className="text-left link text-blue m-3">
            Login
          </NavLink>
        </div>
        <div className="flex-b">
          <p className="title-text text-left font-size m-0"></p>
          <span>
            <p className="step-text">{`STEP ${step}/2`}</p>
            <p className="step-text profile-info-text">{step === 1 ? 'Request PIN' : 'Update Password'} </p>
          </span>
        </div>
        {step === 1 ? (
          <form className="form-container" onSubmit={handleSubmit}>
            <div className="mb-15">
              <InputField
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (e.target.value.length === 0) {
                    setError('Email is required');
                  } else {
                    setError('');
                  }
                }}
                placeholder="Email"
              />
              <span className="error">{error?.length ? error : null}</span>
            </div>

            <Button loading={loading} disabled={submitDisable ? submitDisable : loading} alert={alert}>
              Send PIN
            </Button>
          </form>
        ) : (
          <ConfirmPassword setStep={(st) => setStep(st)} />
        )}
      </section>
    </Localize>
  );
}
